const LAST_RECORDED_DATA_STORAGE_KEY = 'lattice.last-debug-data'

export { LAST_RECORDED_DATA_STORAGE_KEY }
